import React from 'react';
import { stub } from '@xsk/frontend-skeleton';

export default class TerminalMatch extends React.Component {
    render() {
        return(
            <stub.ui.ListPage
                module='cleanTerminalMatch'
                {...this.props}
                listMetadataKey='cleanData-terminalMatch-list'
                filterMetadataKey='cleanData-terminalMatch-filter'
            />
        )
    }

}
